import classNames from 'classnames';
import React, { useMemo, useState } from 'react';

import Icon, { SearchOutlined } from '@ant-design/icons';
import FilterIcon from '@icons/emp/filter-icon.svg';

import styles from './index.less';
import {
  EDimensionListFilter,
  ETableDeployedFilter,
  ETableMappedFilter,
  ETablePredefinedFilter,
  ITableSubHeader,
  TTableFilter,
} from './typed';

const TableSubHeader = ({
  type = 'Mapped',
  onClick,
  showSearch = true,
  onSearchClick,
}: ITableSubHeader) => {
  const [activeFilter, setActiveFilter] = useState<TTableFilter | null>(ETableMappedFilter.ALL);

  const tableFilterNames = useMemo(() => {
    switch (type) {
      case 'Mapped':
        return Object.keys(ETableMappedFilter).filter((v) => isNaN(Number(v)));
      case 'Deployed':
        return Object.keys(ETableDeployedFilter).filter((v) => isNaN(Number(v)));
      case 'Predefined':
        return Object.keys(ETablePredefinedFilter).filter((v) => isNaN(Number(v)));
      case 'Dimension_List':
        return Object.keys(EDimensionListFilter).filter((v) => isNaN(Number(v)));
      default:
        return [];
    }
  }, [type]);

  const filterItem = (filterName: string) => {
    switch (type) {
      case 'Mapped':
        return ETableMappedFilter[filterName];
      case 'Deployed':
        return ETableDeployedFilter[filterName];
      case 'Predefined':
        return ETablePredefinedFilter[filterName];
      case 'Dimension_List':
        return EDimensionListFilter[filterName];
      default:
        break;
    }
  };

  const Cells = tableFilterNames.map((filterName) => {
    return (
      <div
        className={classNames(styles.subHeaderCell, {
          [styles.subHeaderCellActive]: activeFilter === filterItem(filterName),
        })}
        onClick={() => {
          setActiveFilter(filterItem(filterName));
          onClick?.(filterItem(filterName));
        }}
        key={filterName}
      >
        {filterName}
      </div>
    );
  });

  return (
    <div className={styles.tableSubHeader}>
      <div className={styles.filterContainer}>
        <Icon component={FilterIcon} style={{ fontSize: 14, marginRight: 12 }} />
        {Cells}
      </div>
      {showSearch && (
        <SearchOutlined style={{ color: '#494949', fontSize: '14px' }} onClick={onSearchClick} />
      )}
    </div>
  );
};

export default TableSubHeader;
